// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1tQHd","title":"FrontImage_title__3n7C3"};